// Packages
import { cloneDeep } from "lodash";

export const initUpdateActionFw = ({
  selectedFWInstancesList,
}) => {
  const fwList = selectedFWInstancesList
    .map(row => {
      let fw = cloneDeep(row.original);

      const firmwareList = fw.firmwareList.map((availableFw, index) => {
          return {
            ...cloneDeep(availableFw),
            isSelected: fw.targetFirmwareVersion ? availableFw.version === fw.targetFirmwareVersion : index === 0,
          }
        }
      )

      const result =  {
        ...fw,
        firmwareList,
        targetFirmwareVersion: firmwareList.find(fw => fw.isSelected)?.version ?? null
      }

      return result;
    })

  return fwList;
}

export const getActionSelectorSendRequestParams = ({
  auth,
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiPaths = {
    org: `${apiBaseUrl}/firmware/setting.update`,
    site: `${apiBaseUrl}/sites/:siteId/firmware/setting.update`
  };
  const apiKey = apiPaths[auth.scopeLevel];

  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const restfulParams = isStandaloneMode ? restfulParamsConfig["standalone"] : restfulParamsConfig["nonStandalone"];

  return {
    apiKey,
    restfulParams
  };
}

const getFirmwareId = ({
  fw,
  openedAction
}) => {
  let firmwareId = null;

  if (openedAction.key === "updateNow") {
    const selectedFW = fw.firmwareList.find(loopFw => loopFw.isSelected);
    firmwareId = selectedFW?.id ?? null;
  } else {
    firmwareId = fw.firmwareId;
  }

  return firmwareId;
}

const getTargetFirmwareId = ({
  fw,
  openedAction
}) => {
  let targetFirmwareId = null;

  if (openedAction.key === "scheduleUpdate") {
    const selectedFW = fw.firmwareList.find(loopFw => loopFw.isSelected);
    targetFirmwareId = selectedFW?.id ?? null;
  } else {
    targetFirmwareId = null;
  }

  return targetFirmwareId;
}

const getTargetFirmwareSchedule = ({
  fw,
  openedAction
}) => {
  let targetFirmwareSchedule = null;

  if (openedAction.key === "scheduleUpdate") {
    targetFirmwareSchedule = fw.targetFirmwareSchedule;
  } else {
    targetFirmwareSchedule = null;
  }

  return targetFirmwareSchedule;
}

export const getUpgradeWindow = ({ fw }) => {
  const {
    targetFirmwareScheduleDate,
  } = fw;

  return targetFirmwareScheduleDate ? targetFirmwareScheduleDate + "(" + fw.siteTimezone + ")" : null;
}

export const getIsInvalid = ({
  selectedFWList,
  openedAction
}) => {
  let isInvalid = false;

  const isTargetFirmwareVersionInValid = selectedFWList.length === 0 || selectedFWList.some(fw => fw.targetFirmwareVersion == null);
  const isTargetFirmwareScheduleInValid = selectedFWList.length === 0 || selectedFWList.some(fw => fw.targetFirmwareSchedule == null);

  if(openedAction?.key === "updateNow"){
    isInvalid = isTargetFirmwareVersionInValid;
  }else if(openedAction?.key === "scheduleUpdate"){
    isInvalid = isTargetFirmwareVersionInValid || isTargetFirmwareScheduleInValid;
  }else if (openedAction?.key  === "cancelUpdate"){
    // Scheduled FW means cancelable.
    isInvalid = isTargetFirmwareScheduleInValid;
  }

  return isInvalid;
}

// Base on the mentioned rule of issue #85.
export const getUpdateSelectorCleanSavingPayload = ({
  selectedFWList,
  openedAction
}) => {
  const savingPayloads = selectedFWList.map(fw => {
    const {
      lastUpgradeTimeDate,
      lastUpgradeTimeDateLabel,
      targetFirmwareScheduleDate,
      targetFirmwareScheduleDateLabel,
      latestFirmwareVersion,
      latestFirmwareVersionHasReleaseNote,
      ...restFw
    } = fw;

    return {
      ...restFw,
      upgradeMethod: openedAction.payload.upgradeMethod,
      isUpgradeNow: openedAction.payload.isUpgradeNow,
      firmwareId: getFirmwareId({ fw, openedAction }),
      targetFirmwareId: getTargetFirmwareId({ fw, openedAction }),
      targetFirmwareSchedule: getTargetFirmwareSchedule({ fw, openedAction }),
      upgradeWindow: getUpgradeWindow({ fw }),
    }
  })

  return {
    data: savingPayloads
  }
}